import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

export const theme = responsiveFontSizes(
  createMuiTheme({
    palette: {
      primary: {
        // main: "#ff1447"
        // main: "#f6416c" colorhunt
        main : "#dc353c"
      },
      secondary: {
        main: "#FFFFFF",
        surface: "#F8F9FA",
        400: "#DEDEDE"
      },
      success:{
        // main : "#00b8a9" colorhunt
        main: "#1d9a38" 
      },
      info: {
        // main : "#41b3f6" colorhunt
        main: "#3580dc"
      },
      warning: {
        // main : "#f6b641" colorhunt
        main: "#dca935"
      },
      danger: {
        // main : "#f6416c" colorhunt
        main : "#dc353c"
      },
      black: {
        main: "#303030"
      }
    }
  })
);
